import navToListing from '../../helpers/navToListing';
import ListingPreviewCard from '../ListingPreviewCard';
import useFetchListingsByIds from '@th/frontend-shared/src/hooks/queries/useFetchListingsByIds';
import { PreviewLocation } from '../Map';
import Loader from '../Loader';
import NoListingsFoundPromptActionButton from './NoListingsFoundPromptActionButton';
import useIsListingBlurred from '../../hooks/useIsListingBlurred';
import PreviewSidebarItem from './PreviewSidebarItem';

type Props = {
  previewLocations: Array<PreviewLocation>;
  onPreviewCardHover: (previewLocation: PreviewLocation) => void;
};

export default function PreviewListingsSidebar({
  previewLocations,
  onPreviewCardHover,
}: Props) {
  const { listings: listingPreviews, isEnabledAndLoading } =
    useFetchListingsByIds(
      previewLocations.map(location => location.listingIds).flat(),
      {
        keepPreviousData: true,
      },
    );

  return (
    <div className="overflow-y-auto flex-1">
      {isEnabledAndLoading ? (
        <div className="flex justify-center items-center h-full">
          <Loader />
        </div>
      ) : listingPreviews.length === 0 ? (
        <div className="p-4 flex flex-col flex-1 justify-center items-center h-full">
          <p className="text-center">There are no listings for this search</p>
          <p className="text-center">
            Try broadening your search or check back later
          </p>
          <div className="mt-4">
            <NoListingsFoundPromptActionButton />
          </div>
        </div>
      ) : (
        <div className="grid px-4 pt-2 gap-4 lg:grid-cols-1 xl:grid-cols-2 ">
          {listingPreviews.map(listing => {
            return (
              <PreviewSidebarItem
                key={listing.id}
                listing={listing}
                onMouseEnter={() => {
                  onPreviewCardHover(
                    previewLocations.find(location =>
                      location.listingIds.includes(listing.id),
                    ),
                  );
                }}
                onMouseLeave={() => {
                  onPreviewCardHover(null);
                }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
